import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the iwaIllustrationPage state domain
 */

const selectIwaIllustrationPageDomain = state =>
  state.get('iwaIllustrationPage', initialState);

/**
 * Other specific selectors
 */

/**
 * Default selector used by IwaIllustrationPage
 */

const makeSelectIwaIllustrationPage = () =>
  createSelector(selectIwaIllustrationPageDomain, substate => substate.toJS());

const makeSelectLifeAssured = () =>
  createSelector(selectIwaIllustrationPageDomain, substate =>
    substate.get('lifeAssured').toJS(),
  );

const makeSelectInitialLifeAssured = () =>
  createSelector(selectIwaIllustrationPageDomain, substate =>
    substate.get('initialLifeAssured').toJS(),
  );

const makeSelectError = () =>
  createSelector(selectIwaIllustrationPageDomain, substate =>
    substate.get('errorData').toJS(),
  );

const makeSelectConfig = () =>
  createSelector(selectIwaIllustrationPageDomain, substate =>
    substate.get('iwaConfig').toJS(),
  );

const makeSelectBiTableValues = () =>
  createSelector(selectIwaIllustrationPageDomain, substate =>
    substate.get('biTableValues').toJS(),
  );

const makeSelectFiaCharge = () =>
  createSelector(selectIwaIllustrationPageDomain, substate =>
    substate.get('fiaData').toJS(),
  );

const makeSelectProductConfig = () =>
  createSelector(selectIwaIllustrationPageDomain, substate =>
    substate.get('productConfig').toJS(),
  );

const makeSelectQuoteId = () =>
  createSelector(selectIwaIllustrationPageDomain, substate =>
    substate.get('quoteId'),
  );

const makeSelectApplicationId = () =>
  createSelector(selectIwaIllustrationPageDomain, substate =>
    substate.get('applicationId'),
  );

const makeSelectBiPdf = () =>
  createSelector(selectIwaIllustrationPageDomain, substate =>
    substate.get('benefitIllustrationPdf'),
  );

const makeSelectStatus = () =>
  createSelector(selectIwaIllustrationPageDomain, substate =>
    substate.get('status'),
  );

const makeSelectReferenceNumber = () =>
  createSelector(selectIwaIllustrationPageDomain, substate =>
    substate.get('referenceNumber'),
  );

const makeSelectCloneStatus = () =>
  createSelector(selectIwaIllustrationPageDomain, substate =>
    substate.get('successClone'),
  );

const makeSelectemailSentStatus = () =>
  createSelector(selectIwaIllustrationPageDomain, substate =>
    substate.get('emailSent'),
  );

const makeSelectEmailErrorMessage = () =>
  createSelector(selectIwaIllustrationPageDomain, substate =>
    substate.get('emailErrorMessage'),
  );

const makeSelectFormInput = () =>
  createSelector(selectIwaIllustrationPageDomain, substate =>
    substate.get('input').toJS(),
  );

export {
  selectIwaIllustrationPageDomain,
  makeSelectIwaIllustrationPage,
  makeSelectLifeAssured,
  makeSelectProductConfig,
  makeSelectFiaCharge,
  makeSelectConfig,
  makeSelectError,
  makeSelectQuoteId,
  makeSelectApplicationId,
  makeSelectBiPdf,
  makeSelectStatus,
  makeSelectReferenceNumber,
  makeSelectInitialLifeAssured,
  makeSelectBiTableValues,
  makeSelectCloneStatus,
  makeSelectemailSentStatus,
  makeSelectEmailErrorMessage,
  makeSelectFormInput,
};
